// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--XvS32";
export var menu2 = "Menu-module--menu2--3eo4b";
export var menuOpen = "Menu-module--menuOpen--3enw2";